import { DownloadResource, Heading, LinkResource } from "@govlaunch/web";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";

interface IStoryResourcesProps {
  resources: IStoryFieldsFragment["resources"];
}

export default function StoryResources({ resources }: IStoryResourcesProps) {
  return (
    <>
      <Heading as="h3" color="blue.500" fontWeight="bold" fontSize="18" mb={4}>
        <FormattedMessage defaultMessage="Resources" id="c/KktL" />
      </Heading>
      <div css={{ paddingLeft: 10 }}>
        {resources &&
          resources.map((resource, index: any) => {
            if (resource.__typename === "LinkResource") {
              return (
                // ok to disable eslint for react/no-array-index-key because the user can not change the list from the UI
                // eslint-disable-next-line
                <div key={`${resource.title}_${index}`} css={{ marginBottom: 8 }}>
                  <LinkResource href={resource.url || "#"}>{resource.title}</LinkResource>
                </div>
              );
            }

            if (resource.__typename === "DownloadResource") {
              return (
                // eslint-disable-next-line
                <div key={`${resource.title}_${index}`} css={{ marginBottom: 8 }}>
                  <DownloadResource href={resource.url || "#"}>{resource.title}</DownloadResource>
                </div>
              );
            }

            return null;
          })}
      </div>
    </>
  );
}
